<template>
  <DrField :for="$attrs.id" :label="$attrs['data-label']" :error="$attrs.error" :formShake="formShake">
    <textarea
      v-bind="$attrs"
      :value="value"
      @input="$emit('input', $event.target.value)"
      v-on="listeners"
    />
    <div class="help">
      <slot name="help"/>
    </div>
  </DrField>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    /** @ignore */
    value: {
      type: [String, Number],
      default: '',
    },
    formShake: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        input: (event) => this.$emit('input', event.target.value),
      }
    },
  },
}
</script>

<docs>
This is a transparent component of a `textarea`

```vue
<DrTextarea error="More information">
  Something
</DrTextarea>
```
</docs>
